import { CommentType } from './commenttype.enum';

export class Comment {
  id: number;
  type: CommentType;
  racf: string;
  text: string;
  timestamp: Date;
  authorityChangeRequestId: number;

  constructor(comment: IComment) {
    this.id = comment.id;
    this.type = comment.type;
    this.racf = comment.racf;
    this.text = comment.text;
    this.timestamp = new Date(comment.timestamp);
    this.authorityChangeRequestId = comment.authorityChangeRequestId;
  }
}

export interface IComment {
  id: number;
  type: CommentType;
  racf: string;
  text: string;
  timestamp: number;
  authorityChangeRequestId: number;
}
